import { Helmet } from 'react-helmet-async';

import { useContext, useEffect, useState } from 'react';
// @mui
import {
  Autocomplete,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  Grid,
  MenuItem,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
// components

import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/user';
import { useNavigate } from 'react-router-dom';
import { AppContext } from 'src/components/Context/AppContext/app.context';
import { DeleteCompanies, GetCompaniesByUserCompany, GetUserCompanies } from 'src/components/services/httpServices';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'id', label: 'Id', alignRight: false },
  { id: 'companyName', label: 'Company Operating Name', alignRight: false },
  { id: 'companyGst', label: 'Company GST#', alignRight: false },
  // { id: '' },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    let sorted = [];
    sorted = array.filter((_user) => {
      const companyNameMatch = _user?.companyName?.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      const companyGstMatch = _user?.companyGst ? _user?.dateOfBirth?.includes(query) : false;

      return companyNameMatch || companyGstMatch;
    });
    //console.log('sorted:', sorted);
    return sorted;
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function CompanyListPageByUserCompany() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [USERLIST, setUsersList] = useState([]);
  const [COMPANIESLIST, setCompaniesList] = useState([]);
  const [message, setMessage] = useState('');
  const [saved, setSaved] = useState(false);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [openMessage, setOpenMessage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedUserCompany, setSelectedUserCompany] = useState(1);
  const [userCompanies, setUserCompanies] = useState([]);
  let { employers, dataFetched } = useContext(AppContext);
  const fetchRemaining = async () => {
    // const response = await RemaingCompanies();
    if (employers.length > 0 && dataFetched) {
      let savedUserWiesCompnies = employers.filter((x) => x.mstUserCompanyId == selectedUserCompany);
      setCompaniesList((prev) => [...prev, ...savedUserWiesCompnies]);
    }
  };

  // const fetchRemaining = async () => {
  //   const response = await RemCompaniesByUserCompany(selectedUserCompany);
  //   if (response !== null) {
  //     setCompaniesList((prev) => [...prev, ...response]);
  //   }
  // };
  useEffect(
    () => {
      const fetch = async () => {
        const companies = await GetUserCompanies();
        const response = await GetCompaniesByUserCompany(selectedUserCompany);
        if (response !== null) {
          setCompaniesList(response);
          setUserCompanies(companies);
          setLoading(false);
          fetchRemaining();
          // setNotificationCount(response.data.length);

          //       console.log('UsersLit', response);
        }
      };
      fetch();
    },
    [selectedUserCompany]
    // [pr],
    // [pr?.prQ1Collection]
  );
  const rowClicked = async (row) => {
    // console.log('row', row);
    setSelectedRow(row);

    //  navigate(`/app/CompanyTabs/${row.id}/${false}`);
  };
  const rowClickedHandle = async (row) => {
    navigate(`/app/CompanyTabs/${row.id}/${false}`);
  };
  const deleteUsersList = async (selectedUsersList) => {
    const payload = {
      ids: selected,
    };

    // console.log(payload);
    let response = await DeleteCompanies(payload);
    // console.log('PostResponse:', response);

    if (response.status == 200) {
      const isSelected = (user) => {
        let check = selected.includes(user.id);
        return !check;
      };
      const list = COMPANIESLIST.filter((e) => {
        if (isSelected(e)) {
          return e;
        }
      });
      //    console.log('Users:', list);
      setCompaniesList(list);
      setSelected([]);
      setMessage(response.data);
      setSaved(true);
      setOpenMessage(true);
      // setTimeout(() => {
      //   navigate('/app/user');
      // }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpenMessage(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpenMessage(false);
  };
  const handleDocuments = () => {
    // console.log('row:', selectedRow);
    navigate(`/app/Attachments/${selectedRow.id}/${false}`);
  };
  const handlePerformActivity = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/PerformActivity/${selectedRow.id}/${false}`);
  };

  const handleEdit = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/EditCompany/${selectedRow.id}`);
  };
  const handleNotes = () => {
    //console.log('row:', selectedRow);
    navigate(`/app/CompanyNotes/${selectedRow.id}`);
  };
  const handleDetails = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/CompanyDetails/${selectedRow.id}`);
  };
  const handelNewCompany = () => {
    navigate('/app/AddCompany');
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = COMPANIESLIST.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  const handleTasks = () => {
    // console.log('row:', selectedRow);
    navigate(`/app/CreateTasks/${selectedRow.id}/${false}`);
  };
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - COMPANIESLIST.length) : 0;

  const filteredUsers = applySortFilter(COMPANIESLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Employers | Immigration System </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Employers
          </Typography>
          <Stack direction="row" spacing={4}>
            <Autocomplete
              id="userCompanies"
              size="small"
              options={userCompanies}
              getOptionLabel={(company) => company.name}
              renderInput={(params) => (
                <TextField {...params} sx={{ width: 300, height: 40 }} label="Select Company" variant="outlined" />
              )}
              onChange={(event, company) => setSelectedUserCompany(parseInt(company.id))}
            />
            <Button variant="contained" onClick={handelNewCompany} startIcon={<Iconify icon="eva:plus-fill" />}>
              Add Company
            </Button>
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Card>
            <UserListToolbar
              numSelected={selected.length}
              selectedUsers={selected}
              setSelected={setSelected}
              filterName={filterName}
              onFilterName={handleFilterByName}
              deleteUsers={deleteUsersList}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={COMPANIESLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      {
                        /* const { id, name, role, status, company, userEmail } = row; */
                      }
                      const { id, companyName, companyGst } = row;
                      const selectedCompany = selected.indexOf(id) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={selectedCompany}
                          onClick={() => rowClicked(row)}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedCompany} onChange={(event) => handleClick(event, id)} />
                          </TableCell>
                          {/* <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {id}
                              </Typography>
                            </Stack>
                          </TableCell> */}

                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {companyName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {companyGst}
                              </Typography>
                            </Stack>
                          </TableCell>

                          {/* <TableCell align="right">
                            <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500]}
              component="div"
              count={COMPANIESLIST.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 190,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edits
        </MenuItem>
        <MenuItem onClick={handleDetails}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 1 }} />
          Details
        </MenuItem>
        <MenuItem onClick={handleDocuments}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 1 }} />
          Documents
        </MenuItem>
        <MenuItem onClick={handleTasks}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 1 }} />
          Tasks
        </MenuItem>
        <MenuItem onClick={handlePerformActivity}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 1 }} />
          Perform Activity
        </MenuItem>
        <MenuItem onClick={handleNotes}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 1 }} />
          Notes
        </MenuItem>
      </Popover>
    </>
  );
}
